'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = makeLayerGetter;

var _layerWebsdk = require('layer-websdk');

var _layerWebsdk2 = _interopRequireDefault(_layerWebsdk);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeLayerGetter(_ref) {
  var _this = this;

  var authStore = _ref.authStore,
      auth0ClientId = _ref.auth0ClientId,
      appId = _ref.appId,
      delegationEndpoint = _ref.delegationEndpoint;

  function getDelegationToken(token, nonce) {
    return _axios2.default.post(delegationEndpoint, {
      client_id: auth0ClientId,
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      id_token: token,
      target: auth0ClientId,
      api_type: 'layer',
      nonce: nonce,
      scope: 'openid'
    }).then(function (r) {
      return r.data.id_token;
    });
  }

  var layerGetter = (0, _memoize2.default)(function () {
    return new _promise2.default(function (resolve) {
      var client = new _layerWebsdk2.default.Client({
        appId: appId,
        isTrustedDevice: true
      });

      client.on('challenge', function () {
        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(evt) {
          var delegationToken;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return getDelegationToken(authStore.token, evt.nonce);

                case 2:
                  delegationToken = _context.sent;

                  evt.callback(delegationToken);

                case 4:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());

      client.on('ready', function () {
        resolve(client);
      });

      authStore.onLogin(function () {
        // Layer does session management - how nice
        client.connect(authStore.user.id);
      });
    });
  });

  authStore.onLogout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
    var existing;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return layerGetter.cache.get(undefined);

          case 2:
            existing = _context2.sent;

            if (existing) {
              existing.logout();
              existing.destroy();
            }

            layerGetter.cache.clear();

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  })));

  return layerGetter;
}
//# sourceMappingURL=layerUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/layerUtil.js
// module id = 638
// module chunks = 0